import { useEffect, useState } from "react";
import { ExternalLink } from "lucide-react";
import { api } from "@/lib/api";

export const AdSlot = ({ placement, compact = false }) => {
  const [ad, setAd] = useState(null);
  useEffect(() => {
    api.get(`/ads?placement=${placement}`).then(({ data }) => {
      if (data[0]) { setAd(data[0]); api.post(`/ads/${data[0].id}/view`); }
    });
  }, [placement]);
  if (!ad) return null;
  const click = () => api.post(`/ads/${ad.id}/click`);
  const external = ad.target_url.startsWith("https://");
  return <aside className={`ad-slot ad-${ad.format} ${compact ? "compact" : ""}`} data-testid={`ad-slot-${placement}`}><a href={ad.target_url} target={external ? "_blank" : undefined} rel={external ? "noreferrer" : undefined} onClick={click} data-testid={`ad-link-${ad.id}`}><img src={ad.image} alt="" loading="lazy" decoding="async"/><div><small>CONTENU PARTENAIRE · {ad.advertiser}</small><strong>{ad.title}</strong><span>{ad.description}</span></div>{external&&<ExternalLink/>}</a></aside>;
};